// extracted by mini-css-extract-plugin
export default {"TooltipInfo":"_TooltipInfo--MfQR2","Icon":"_Icon--GJEwe","Message":"_Message--atO2w","DisabledIcon":"_DisabledIcon--MJTuU"};